import React, { useEffect, useState } from 'react'
import KycPendingAlert from '../../Component/Dashboard/kycPendingAlert';
import DemoAdvertiseBanner from '../../Component/Dashboard/DemoAdvertiseBanner';
import JobPostUsingTemplateBanner from '../../Component/Dashboard/jobPostUsingTemplateBanner';
import FreshJobPostBanner from '../../Component/Dashboard/freshJobPostBanner';

import Loader from '../../Component/Common/Loader'
import { addJobComment, postedOppurtunitiesList, updateStatus } from '../../action/jobs';
import { getsessionStorage, getStorage, setsessionStorage } from '../../utils';
import constant from '../../constant';
import PostedJobCount from '../../Component/ListOppurtunity/postedJobCount'
import OpputunityList from '../../Component/ListOppurtunity'
import { toast } from 'react-toastify';
import { isKYCVerified } from '../../action/dashboard';
const Index = () => {
  const [showDemoBanner, setShowDemoBanner] = useState(getStorage(constant.keys.skippedDemoBanner) ? false : true);
  const [kycVerified, setKycVerified] = useState(getsessionStorage(constant.keys.kycVerified));
  const [jobs, setJobs] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('ALL');
  const [filterCount, setFilterCount] = useState(null)


  const fetchJobs = async (nextPage, currentFilter) => {
    if (isLoading || (nextPage > 1 && !hasMore)) return;
    setIsLoading(true);

    try {
      await postedOppurtunitiesList(nextPage, currentFilter).then((res) => {
        if (res.result) {
          const { allCount, liveCount, inCompleteCount, inactiveCount, expiredCount, fetchedPage } = res.result
          setFilterCount({ allCount, liveCount, inCompleteCount, inactiveCount, expiredCount })
          setJobs((prevJobs) =>
            fetchedPage == 1 ? res.result.list : [...prevJobs, ...res.result.list]
          );
          setHasMore(jobs.length + res.result.list < res.result.count);

        }
        else {
          toast.error(res.error)
        }
      })

    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setIsLoading(false);
      setPage(nextPage);
    }
  };
  // Initial fetch
  useEffect(() => {
    fetchJobs(1, filter);

    if (getsessionStorage(constant.keys.kycVerified) === null) {
      isKYCVerified().then((res) => {
        if (res.status) {
          if (res.result.IS_KYC_VERIFIED === 'Y') {
            setKycVerified(true)
            setsessionStorage(constant.keys.kycVerified, true)
          }
          else {
            setKycVerified(false)

            setsessionStorage(constant.keys.kycVerified, false)
          }
        }
      })
    }

  }, []);

  const changeStatus = (id, status) => {
    debugger
    updateStatus({ JOB_ID: id, STATUS: status }).then(res => {
      if (res.status) {
        debugger
        setJobs(jobs.map((item) => {
          if (item.JOB_ID === id) {
            return { ...item, STATUS_BY_EMPLOYER: status };
          }
          return item;
        }));

        toast.success('Status Updated Successfully');
      }
      else {
        toast.error(res.error)
      }
    })
  }

  return (
    <React.Fragment>
      <div className='container-fluid'>
        {isLoading && <Loader />}
        <div className='row'>
          {!kycVerified && <KycPendingAlert />}
          {showDemoBanner && < DemoAdvertiseBanner
            setShowDemoBanner={setShowDemoBanner}
          />}
        </div>

        {jobs && (jobs.length > 0 ? <React.Fragment>
          <PostedJobCount
          />
          <OpputunityList
            filterCount={filterCount}
            jobs={jobs}
            setFilter={setFilter}
            filter={filter}
            setJobs={setJobs}
            page={page}
            setPage={setPage}
            hasMore={hasMore}
            setHasMore={setHasMore}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            fetchJobs={fetchJobs}
            changeStatus={changeStatus}

          />
        </React.Fragment> : <div className='row mt-3'>
          <JobPostUsingTemplateBanner />
          <FreshJobPostBanner />
        </div>
        )}
      </div>
      {/* <Dashboard /> */}
    </React.Fragment>
  )
}

export default Index